import { computed, type ComputedRef, type Ref, useId } from 'vue';

export function useDialogDescriptionId(
  hasDescription: Ref<boolean> | ComputedRef<boolean>,
): ComputedRef<string | undefined> {
  const descriptionId = useId();
  // reka-ui's DialogContent sets aria-describedby to an auto-generated id regardless of
  // whether DialogDescription renders, producing a dangling reference when there's nothing
  // to describe. Only expose a real id when there's content for it to point to.
  return computed(() => (hasDescription.value ? descriptionId : undefined));
}
